module.exports = __webpack_public_path__ + "img/symbol_6.b9078b2f.png";